/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Srp = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 22 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M16.08 1.48a.1.1 0 0 0-.07 0H6h-.05L4.44 3.37h13.12l-1.48-1.89z" /><path d="M20.3 4.66a17.23 17.23 0 0 0-1.07-1.51.8.8 0 0 0-.13-.15L17.2.59A1.47 1.47 0 0 0 16 0H6c-.457 0-.888.21-1.17.57L2.61 3.38l-.06.06c-.304.392-.587.8-.85 1.22-.63 1.1-.5 3.91-.5 3.95.043.582.127 1.16.25 1.73 0 .21.09.48.09.55a1.36 1.36 0 0 0 .37.95v1.31a1.44 1.44 0 0 0 1.37 1.5h1.1a1.45 1.45 0 0 0 1.37-1.5v-.83h10.5v.83a1.45 1.45 0 0 0 1.37 1.5h1.11a1.45 1.45 0 0 0 1.37-1.5v-1.3c.24-.257.37-.598.36-.95.02-.172.05-.342.09-.51.128-.55.212-1.108.25-1.67 0 0 .14-2.96-.5-4.06zM5.19 7.12a.59.59 0 0 1-.59.59H3.31a.6.6 0 0 1-.59-.59v-.41a.59.59 0 0 1 .59-.59H4.6a.58.58 0 0 1 .59.59v.41zm8.77 0a.59.59 0 0 1-.59.59h-5a.6.6 0 0 1-.59-.59v-.41a.59.59 0 0 1 .59-.59h5a.58.58 0 0 1 .59.59v.41zM4.44 3.37l1.48-1.9H16a.1.1 0 0 1 .07 0l1.48 1.89-13.11.01zm14.62 3.75a.59.59 0 0 1-.59.59h-1.15a.6.6 0 0 1-.59-.59v-.41a.59.59 0 0 1 .59-.59h1.15a.58.58 0 0 1 .59.59v.41zM5.88 16.17h10.24v1.35H5.88zM3.18 20.4h15.64v1.35H3.18zM.82 24.63h20.36v1.35H.82z" /></g>
      </g>
    </svg>
  </span>
);

Srp.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Srp.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Srp;
